<template>
  <PageLayout>
    <PageTitle class="page-title">{{ $route.meta.title }}</PageTitle>
      <Breadcrumbs/>
      <Users class="mt-4" />
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Users from '../../views/partners/Index.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
// import { Breadcrumbs } from "@/shared/ui/breadcrumbs";
import Breadcrumbs from '@/components/ui/Breadcrumbs';

export default {
  created() {
    this.changeActivePage(pages.CLIENTS_AND_PARTNERS);
  },
  components: {Breadcrumbs, PageLayout, PageTitle, Users },
  computed: {
    ...mapGetters('layoutModule', ['isMobile', 'isTablet', 'windowWidth']),
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>

</style>
